import { useDispatch, useSelector } from 'react-redux';
import { CommanderThunkDispatch } from '@mews-commander/types';
import { IconName } from '@optimus-web/core';
import { TextKey, FeatureFlag } from '@mews-commander/enums';
import { useFeatureFlag } from '@mews/framework';
import { open, isSalesForceInitialized } from '@mews-commander/chat';
import { createListItem } from '../../helpers';

export const HelpCenterMenuItem = () => {
    const isSalesForceChatInitialized = useSelector(isSalesForceInitialized);
    const dispatch: CommanderThunkDispatch = useDispatch();
    const adaEmbeddedFeatureFlagEnabled = useFeatureFlag(FeatureFlag.adaEmbeddedFeatureFlagEnabled);

    if (!isSalesForceChatInitialized || adaEmbeddedFeatureFlagEnabled) return null;

    const handleOnAfterClick = () => {
        dispatch(open());
    };

    return createListItem({
        textKey: TextKey.HelpCenter,
        iconName: IconName.HelpCenter,
        isMainItem: true,
        onAfterClick: handleOnAfterClick,
    });
};
